// extracted by mini-css-extract-plugin
module.exports = {"stepsMainWrapper":"_RsOt","stepCardWrapper":"_10uEn","stepCard":"_2dMbl","stepCardTextWrapper":"_2im2r","titleContainer":"E9g44"};